function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M23.7686,9.367 C23.4146,8.944 22.7856,8.885 22.3596,9.239 L16.6376,14.007 L1.9996,14.007 C1.4476,14.007 0.9996,14.455 0.9996,15.007 L0.9996,19.613 C0.9996,22.036 2.9716,24.007 5.3946,24.007 L18.6056,24.007 C21.0286,24.007 22.9996,22.036 22.9996,19.613 L22.9996,15.007 C22.9996,14.455 22.5526,14.007 21.9996,14.007 L19.7626,14.007 L23.6406,10.775 C24.0646,10.422 24.1226,9.791 23.7686,9.367"
}), React.createElement("path", {
  d: "M7.0001,11.0071 C7.2581,11.0071 7.5141,10.9071 7.7071,10.7141 L11.7071,6.7141 C12.0671,6.3541 12.1001,5.7801 11.7811,5.3821 L7.7811,0.3821 C7.6131,0.1731 7.3681,0.0391 7.1011,0.0121 C6.8361,-0.0159 6.5651,0.0671 6.3591,0.2391 L0.3591,5.2391 C0.1171,5.4411 -0.0159,5.7451 0.0011,6.0601 C0.0191,6.3751 0.1831,6.6641 0.4451,6.8391 L6.4451,10.8391 C6.6141,10.9521 6.8081,11.0071 7.0001,11.0071"
}), React.createElement("path", {
  d: "M13.0001,10.0071 C13.5521,10.0071 14.0001,9.5591 14.0001,9.0071 C14.0001,8.4551 13.5521,8.0071 13.0001,8.0071 C12.4481,8.0071 12.0001,8.4551 12.0001,9.0071 C12.0001,9.5591 12.4481,10.0071 13.0001,10.0071"
}), React.createElement("path", {
  d: "M11.0001,11.0071 C10.4481,11.0071 10.0001,11.4551 10.0001,12.0071 C10.0001,12.5591 10.4481,13.0071 11.0001,13.0071 C11.5521,13.0071 12.0001,12.5591 12.0001,12.0071 C12.0001,11.4551 11.5521,11.0071 11.0001,11.0071"
})));

var SvgIngredients = function SvgIngredients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 31.25",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIngredients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ingredients.4a00cc69.svg";
export { ForwardRef as ReactComponent };